/**
 * Browser entry point for the cross-origin preview iframe bundle.
 *
 * This is what the iframe loads at runtime. The iframe document's
 * `<script src="oj-preview-runtime.js" type="module">` invokes this
 * file; on load it calls `bootIframeRuntime()` which:
 *
 *   1. Registers `<oj-*>` Custom Elements (so widget primitives paint
 *      labelled placeholders at preview time + real interactive UI on
 *      published pages).
 *   2. Posts `ready` upward so the parent starts pushing tree-update
 *      messages.
 *   3. Listens for tree-update / set-selection / set-tokens / set-
 *      viewport messages and morphdom-diffs the compiled HTML into
 *      the document body.
 *
 * Same script ships to two places once `preview.outerjoyn.com` is
 * deployed (PR22):
 *
 *   - `https://preview.outerjoyn.com/` — editor preview iframe.
 *   - `https://cdn.outerjoyn.com/oj-preview-runtime.js` (Phase 4.5+) —
 *     loaded by published customer pages so the same widgets render
 *     in production. Phase 4 only ships the editor-preview half;
 *     publish-page integration ships with the SDK runtime upgrades
 *     (W3, deferred per the spec).
 *
 * Why a separate entry instead of inlining inside the editor's main
 * bundle: this file gets bundled standalone and served from the
 * preview origin. It must NOT pull in React, the editor shell, or
 * anything Postgres-shaped. Keeping a dedicated entry forces the
 * bundler to tree-shake correctly.
 */

import { bootIframeRuntime } from './iframeRuntime';

bootIframeRuntime();
